import React from 'react';
import Callout from './callout';
export default function index({ bodyCopy }) {
  return (
    <Callout calloutTitle="Get Important Information About AVEED<sup>&reg;</sup>" buttonTitle="View Medication Guide" buttonLink="https://endodocuments.com/AVEED/MG" isTargetBlank={true} bodyCopy={bodyCopy}>
      <p>Download a complete overview of important drug information, possible side effects, and more.</p>
    </Callout>
  )
}
